(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acc-load-more"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-acc-loadmore]');
  if (!root) return;

  const btn = root.querySelector('[data-acc-loadmore-btn]');
  const spinner = root.querySelector('[data-acc-loadmore-spinner]');
  const progress = root.querySelector('[data-acc-loadmore-progress]');
  const label = root.querySelector('[data-acc-loadmore-label]');

  const productList = document.querySelector('product-list');
  if (!productList) return;

  let nextUrl = null;
  const pagination = document.querySelector('.collection__pagination');
  if (pagination) pagination.style.display = 'none';

  function detectNext(doc) {
    const link = (doc || document).querySelector('.collection__pagination a[rel="next"]');
    return link ? link.getAttribute('href') : null;
  }

  function updateProgress() {
    if (!progress) return;
    const cards = productList.querySelectorAll('.product-card, [data-product-id]');
    const total = parseInt(productList.getAttribute('data-total-count') || '0', 10);
    if (total > 0) {
      progress.textContent = 'Showing ' + cards.length + ' of ' + total;
      progress.hidden = false;
    }
  }

  nextUrl = detectNext();
  if (nextUrl) { btn.hidden = false; }
  updateProgress();

  btn.addEventListener('click', async function () {
    if (!nextUrl || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    spinner.hidden = false;

    try {
      const res = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('Fetch failed: ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newList = doc.querySelector('product-list');
      if (newList) {
        const newCards = newList.children;
        const frag = document.createDocumentFragment();
        while (newCards.length) frag.appendChild(newCards[0]);
        productList.appendChild(frag);

        if (window.history && window.history.pushState) {
          window.history.pushState({}, '', nextUrl);
        }

        nextUrl = detectNext(doc);
        updateProgress();
        if (!nextUrl) {
          btn.hidden = true;
          if (progress) {
            const cards = productList.querySelectorAll('.product-card, [data-product-id]');
            progress.textContent = 'All ' + cards.length + ' covers loaded';
          }
        }
      } else {
        btn.hidden = true;
      }
    } catch (err) {
      console.error('[acc-load-more]', err);
      if (label) label.textContent = 'Try again';
    } finally {
      btn.removeAttribute('aria-busy');
      spinner.hidden = true;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
